import React from 'react';
import './style/spinner.css';
const Spinner = ()=>{
    return(
        <>
            <span className="loader"><span className="load">Loading</span></span>
        </>
    )
}

export default Spinner;